<template>
  <div>
    <h3 :style="titleStyle">{{ timeTitle }}</h3>
    <div>
      <v-layout row>
        <v-flex xs9>
          <div
            class="ml-2 mb-3"
          >
            <span :style="addressStyle">{{ pickupInfo }}</span>
          </div>
        </v-flex>
        <v-flex
          xs3
          text-xs-right
        >
          <div
            v-if="editable"
            class="mr-3"
            style="margin-top: -5px;"
          >
            <v-btn
              icon
              small
              @click="openDialog"
            >
              <span class="mr-1" :style="changeStyle">{{ $t('change') }}</span>
              <v-icon
                small
                :color="theme.trashcan_color"
              >fas fa-edit</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </div>
<!--    <div>-->
<!--      <v-btn-->
<!--        block-->
<!--        dark-->
<!--        :color="theme.address_bg_color"-->
<!--        @click="openDialog"-->
<!--      >-->
<!--        <v-layout-->
<!--          row-->
<!--          align-center-->
<!--          :style="timerTextStyle"-->
<!--        >-->
<!--          <v-flex-->
<!--            xs8-->
<!--            class="text-xs-left"-->
<!--          >-->
<!--            <span>{{ pickupInfo }}</span>-->
<!--          </v-flex>-->
<!--          <v-flex-->
<!--            v-if="editable"-->
<!--            xs4-->
<!--            class="text-xs-right"-->
<!--          >-->
<!--            <span>{{ $t('change') }}</span>-->
<!--            <v-icon-->
<!--              small-->
<!--            >fas fa-edit</v-icon>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--      </v-btn>-->
<!--    </div>-->
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="380"
    >
      <v-card>
        <v-card-title :style="timeTitleStyle">{{ selectTimeTitle }}</v-card-title>
        <v-divider />
        <horizontal-scroll
          v-if="dates.length > 1"
          class="ma-2"
        >
          <div
            v-for="(date, index) in dates"
            :key="index"
            class="mr-2 text-xs-center"
            :style="dayStyle(date.date, date.hasSlots)"
            @click="selectDate(date.date, date.hasSlots)"
          >
            <v-layout column>
              <v-flex>
                <span class="smaller">{{ date.month.toUpperCase() }}</span>
              </v-flex>
              <v-flex>
                {{ date.day }}
              </v-flex>
              <v-flex>
                <span class="smaller">{{ date.weekDay.toUpperCase() }}</span>
              </v-flex>
            </v-layout>
          </div>
        </horizontal-scroll>
        <v-card-text :style="timerStyle">
          <v-container
            v-if="loadingTime"
            fill-height
          >
            <v-layout row>
              <v-flex
                xs12
                class="text-xs-center"
              >
                <v-icon small>fas fa-circle-notch fa-spin</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
          <v-radio-group
            v-model="selectedTime"
            v-else-if="times && times.length > 0"
            column
            class="mt-0"
          >
            <v-radio
              v-for="t in times"
              :key="t.time"
              :label="t.availTime <= 0 ? t.time + ' (Unavailable)' : t.label"
              :value="t.time"
              :disabled="t.availTime <= 0"
            />
          </v-radio-group>
          <v-container
            v-else
            fill-height
          >
            <v-layout row>
              <v-flex
                xs12
                class="text-xs-center"
              >
                <span class="font-italic">{{ $t('no_available_slot') }}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <!-- <v-btn
            :color="colors.button1a"
            flat
            @click.native="dialog = false"
          >{{ $t('btn_close') }}</v-btn> -->
          <v-btn
            :color="colors.button1a"
            flat
            @click.native="saveTime"
            block
            :disabled="loadingTime"
          >{{ $t('ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HorizontalScroll from 'vue-horizontal-scroll'

export default {
  components: {
    'horizontal-scroll': HorizontalScroll
  },
  data () {
    return {
      selectedDate: null,
      selectedTime: null,
      dialog: false,
      loadingTime: false,
    }
  },
  props: {
    editable: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'colors', 'mode'
    ]),
    ...mapGetters('cart', [
      'pickupDate', 'pickupTime', 'cartQty', 'dates', 'times'
    ]),
    addressStyle () {
      return {
        color: this.theme.cart_name2_color
      }
    },
    changeStyle () {
      return {
        color: this.theme.trashcan_color
      }
    },
    titleStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    pickupInfo () {
      const date = this.dates.find(d => d.date === this.selectedDate)
      if (!date) {
        return this.$t('select_time')
      } else {
        if (date.weekDay === 'Today') {
          return this.selectedTime ? this.$t('today_at') + this.selectedTime : this.$t('select_time')
        }
        return this.selectedTime ? date.day + ' ' + date.month + ' ' + this.selectedTime : this.$t('select_time')
      }
    },
    timerStyle () {
      return {
        height: this.times && this.times.length > 0 ? '280px' : '100px'
      }
    },
    timerTextStyle () {
      return {
        color: this.theme.address_text_color
      }
    },
    timeTitle () {
      if (this.mode.isTakeaway) return this.$t('pickup_time')
      if (this.mode.isDelivery) return this.$t('delivery_time')
    },
    selectTimeTitle () {
      if (this.mode.isTakeaway) return this.$t('select_pickup_time')
      if (this.mode.isDelivery) return this.$t('select_delivery_time')
    },
    timeTitleStyle () {
      return {
        fontWeight: 800,
        color: this.theme.toolbar_color,
        background: this.theme.toolbar_bg_color
      }
    }
  },
  methods: {
    async openDialog () {
      // if (this.cartQty > 0) {
      //   const text = 'If you change time, your selections in basket will be cleared. Are you sure?'
      //   this.$store.dispatch('responseMessage', {
      //     type: 'error',
      //     title: 'Start New Order',
      //     text: text,
      //     modal: true,
      //     buttons: [
      //       { text: 'Cancel' },
      //       { text: 'Ok', action: 'changeTime', path: 'welcome' }
      //     ]
      //   })
      // } else {
      //   // this.$store.dispatch('changeDiningMode', mode)
      //   this.$router.push({ name: 'welcome' })
      // }
      if (!this.editable) return
      this.$bus.$emit('showFullLoading', true)
      await this.$store.dispatch('cart/fetchTakeawayDates')
      if (!this.pickupDate) {
        this.selectedDate = this.dates[0].date
        this.$store.dispatch('cart/setPickupDate', this.dates[0].date)
      }
      await this.$store.dispatch('cart/fetchTakeawayTimes', this.pickupDate)
      this.$bus.$emit('showFullLoading', false)
      this.dialog = true
    },
    dayStyle (date, hasSlots = true) {
      let styles = {
        border: '1px solid #8a8a8a',
        padding: '4px',
        display: 'inline-block',
        cursor: 'pointer'
      }
      if (this.selectedDate === date && hasSlots) {
        styles.fontWeight = 800
        styles.background = this.theme.toolbar_bg_color
        styles.color = this.theme.toolbar_color
        styles.borderColor = this.theme.toolbar_color
      }
      if (!hasSlots) {
        styles.color = 'grey'
        styles.borderColor = 'grey'
      }
      styles.width = this.$mq === 'xs' ? '65px' : '75px'
      return styles
    },
    saveTime () {
      this.$store.dispatch('cart/setPickupDate', this.selectedDate)
      this.$store.dispatch('cart/setPickupTime', this.selectedTime)
      this.dialog = false
      // this.$bus.$emit('showPromoItemsDialog', true)
    },
    async selectDate (date, hasSlots = true) {
      if (date === this.selectedDate) return
      if (!hasSlots) {
        return
      }
      this.loadingTime = true
      this.selectedDate = date
      await this.$store.dispatch('cart/fetchTakeawayTimes', date)
      this.selectedTime = this.times && this.times.length > 0 ? this.times[0].time : null
      this.loadingTime = false
    }
  },
  async mounted () {
    await this.$store.dispatch('cart/checkPickupDate')
    this.selectedDate = this.pickupDate
    this.selectedTime = this.pickupTime
    if (!this.selectedTime || !this.selectedDate) {
      await this.openDialog()
    } else {
      // So that PromoItems dialog do not inflate and duplicates the screen
      this.$bus.$emit('showPromoItemsDialog', true)
    }
    // Default to first available timing
    const date = this.pickupDate && this.dates.find(d => d.date === this.pickupDate)
      ? this.dates.find(d => d.date === this.pickupDate)
      : (this.dates ? this.dates[0] : null)
    if (date) {
      this.selectedDate = date.date
      this.$store.dispatch('cart/setPickupDate', date.date)
    } else {
      this.$store.dispatch('cart/resetPickupDate')
    }
    const time = this.pickupTime && this.times.find(t => t.time === this.pickupTime && t.availTime > 0)
      ? this.times.find(t => t.time === this.pickupTime && t.availTime > 0)
      : this.times.find(t => t.availTime > 0)
    if (time) {
      this.selectedTime = time.time
      this.$store.dispatch('cart/setPickupTime', time.time)
    } else {
      this.$store.dispatch('cart/resetPickupTime')
    }
  },
}
</script>

<style scoped>
.smaller {
  font-size: 12px;
}
.grey-color {
  color: #8a8a8a;
}
</style>



// WEBPACK FOOTER //
// src/components/TakeawayTimer.vue